import * as React from "react";

function CloudDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15 7.77a3.954 3.954 0 01-1.819 3.33l-.543-.84a2.958 2.958 0 00-1.562-5.448L10.7 4.8l-.1-.36a3.249 3.249 0 00-6.385.806v.419l-.412.073A2.489 2.489 0 002 8.157a2.207 2.207 0 001.326 2.012l-.4.916A3.207 3.207 0 011 8.157a3.568 3.568 0 012.239-3.3 4.254 4.254 0 018.228-1.019A3.961 3.961 0 0115 7.77zm-6.5 6.059v-5.5h-1v5.5l-2.146-2.146-.708.707L8 15.743l3.354-3.353-.708-.707L8.5 13.829z"
  }));
}

export default CloudDownloadIcon;